import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataOperation } from '../../data/DataOperation';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxCompte } from '../ComboBox/ComboBoxCompte';
import { ComboBoxSociete } from '../ComboBox/ComboBoxSociete';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { HintVerticalPosition, HintWrapper } from '../Outils/HintWrapper';
import { MessageBars } from '../Outils/MessageBars';
import './FicheIdentification.css';

/****************************************************************
 PROPS:
    onPeutChargerLeComposant : bool (==false => on ne charge pas le composant ; ==true => on charge)

    onAffichePanelIdentificationVente : bool

    onEnregistrementFiche : méthode
    onFermeFicheIdentificationVente : méthode
    onChange : méthode appelée si onAffichageSansPanel = true
    
    classname : classe CSS (string)
    classnameinner : classe CSS (string)
****************************************************************/

var objetState = {
    operation: {},
    idSociete: 0,

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',

    titrePanel: 'Créer une opération'
};

export class FicheIdentificationVente extends Component {
    _creationContent() {

        return (
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-xxl6">
                        <div className="ms-font-xl titreRubriqueFicheIdentification"><Icon iconName="Chat" /> Bulle de vente</div>
                        <EUITextField
                            data-testid="inputAdresse"
                            label="Adresse"
                            maxLength={MaxLengths.operation.adresseBulleVente}
                            onChange={(event, newValue) => this._onMiseAJourChamp("operation", "adresseBulleVente", newValue)}
                            value={this.state.operation.adresseBulleVente}
                        />
                        <EUITextField
                            data-testid="inputComplementAdresse"
                            label="Complément d'adresse"
                            maxLength={MaxLengths.operation.complementAdresseBulleVente}
                            onChange={(event, newValue) => this._onMiseAJourChamp("operation", "complementAdresseBulleVente", newValue)}
                            value={this.state.operation.complementAdresseBulleVente}
                        />
                        <EUITextField
                            data-testid="inputCP"
                            label="Code postal"
                            maxLength={MaxLengths.operation.cpBulleVente}
                            onChange={(event, newValue) => this._onMiseAJourChamp("operation", "cpBulleVente", newValue)}
                            value={this.state.operation.cpBulleVente}
                        />
                        <EUITextField
                            data-testid="inputVille"
                            label="Ville"
                            maxLength={MaxLengths.operation.villeBulleVente}
                            onChange={(event, newValue) => this._onMiseAJourChamp("operation", "villeBulleVente", newValue)}
                            value={this.state.operation.villeBulleVente}
                        />
                        <EUITextField
                            data-testid="inputHoraireOuverture"
                            label="Horaires d'ouverture"
                            maxLength={MaxLengths.operation.horaireOuvertureBulleVente}
                            onChange={(event, newValue) => this._onMiseAJourChamp("operation", "horaireOuvertureBulleVente", newValue)}
                            value={this.state.operation.horaireOuvertureBulleVente}
                        />
                        <HintWrapper
                            content={<span>Sélectionner une société puis au sein de cette société un commercialisateur. Si vous ne trouvez pas la société ou le commercialisateur, appelez votre gestionnaire de mandats pour mise à jour.</span>}
                            verticalAlign={HintVerticalPosition.bottom}
                            verticalOffset={5}
                        >
                          
                            <ComboBoxSociete
                                avecMandatSurLotDeLOperation
                                data-testid="comboSociete"
                                idOperation={this.state.operation.idOperation}
                                onChange={(event, option, index, value, item) => this._onChangeSociete(item.idSociete)}
                                selectedKey={this.state.idSociete}
                            />

                        </HintWrapper>
                        <ComboBoxCompte
                            data-testid="comboCommercialisateur"
                            avecValeurDefaut={false}
                            disabled={!this.state.idSociete}
                            idLotCommercial={0}
                            idOperation={this.state.operation.idOperation}
                            idSociete={this.state.idSociete}
                            idsTypesMandats={[2]}
                            label="Commercialisateur"
                            onChange={(event, option) => this._onMiseAJourChamp("operation", "loginCompteInterlocuteurBulleDeVente", option.key)}
                            selectedKey={this.state.operation.loginCompteInterlocuteurBulleDeVente}
                        />
                        <EUITextField
                            data-testid="inputTelephone"
                            label="Téléphone"
                            maxLength={MaxLengths.operation.telBulleVente}
                            onChange={(event, newValue) => this._onMiseAJourChamp("operation", "telBulleVente", newValue)}
                            value={this.state.operation.telBulleVente}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xxl6">
                        <div className="ms-font-xl titreRubriqueFicheIdentification"><Icon iconName="LightningBolt" /> Commercial</div>
                        <EUITextField
                            data-testid="inputDescriptifCommercial"
                            label="Descriptif commercial"
                            maxLength={MaxLengths.operation.descriptifCommercial}
                            multiline
                            onChange={(event, newValue) => this._onMiseAJourChamp("operation", "descriptifCommercial", newValue)}
                            rows={10}
                            value={this.state.operation.descriptifCommercial}
                        />
                        <EUITextField
                            data-testid="inputFlashCommercial"
                            label="Flash commercial"
                            maxLength={MaxLengths.operation.flashCommercial}
                            multiline
                            onChange={(event, newValue) => this._onMiseAJourChamp("operation", "flashCommercial", newValue)}
                            rows={6}
                            value={this.state.operation.flashCommercial}
                        />
                        <EUITextField
                            data-testid="inputForces"
                            label="Forces"
                            maxLength={MaxLengths.operation.forces}
                            multiline
                            onChange={(event, newValue) => this._onMiseAJourChamp("operation", "forces", newValue)}
                            rows={6}
                            value={this.state.operation.forces}
                        />
                        <EUITextField
                            data-testid="inputFaiblesses"
                            label="Faiblesses"
                            maxLength={MaxLengths.operation.faiblesses}
                            multiline
                            onChange={(event, newValue) => this._onMiseAJourChamp("operation", "faiblesses", newValue)}
                            rows={6}
                            value={this.state.operation.faiblesses}
                        />
                    </div>
                </div>
            </div>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees() {
        if (this.state.operation.idOperation === undefined) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement de l\'opération en cours'
            });

            var chargementFicheIdentificationVente = DataOperation._chargementFicheIdentification();

            chargementFicheIdentificationVente.then(
                responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let retourData = responseFetch.reponseAPIobjet;
                        let operation = retourData[0];
                        let compteInterlocuteur = retourData[25];

                        let stateTemp = {};
                        stateTemp.operation = operation;
                        stateTemp.idSociete = compteInterlocuteur.idSociete;
                        stateTemp.titrePanel = 'Modifier l\'opération';

                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    _validationFormulaire(item) {
        let estValide = true;

        // Si l'objet n'est pas vide
        if (!(Object.keys(item).length === 0 && item.constructor === Object)) {

        }
        else {
            estValide = false;
        }

        return estValide;
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement de l\'opération en cours'
        });

        let enregistrementOperation = DataOperation._onEnregistrementOperation(this.state.operation);

        enregistrementOperation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                    this.props.onEnregistrementFiche(objetData);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheIdentificationVente();
    }

    _onOpen = () => {
        this._chargementDonnees();
    }

    _onRenderFooterContent = () => {
        let boutonActif = this._validationFormulaire(this.state.operation);

        return (
            <div>
                <PrimaryButton name="btnEnregistrerBulleDeVente" onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!boutonActif}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    _onMiseAJourChamp(nomObjet, nomPropriete, valeur) {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur);
    }

    _onChangeSociete = (key) => {
        this.setState({ idSociete: key });
    };

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
    }

    render() {
        let content = this._creationContent();

        if (this.props.onAffichageSansPanel) {
            return content;
        }
        else {
            return (
                <Panel
                    isOpen={this.props.onAffichePanelIdentificationVente}
                    headerText={this.state.titrePanel}
                    type={PanelType.large}
                    onDismiss={() => this._onAnnulation()}
                    onOpen={() => this._onOpen()}
                    closeButtonAriaLabel="Fermer"
                    onRenderFooterContent={this._onRenderFooterContent}
                >
                    <div className={this.props.classname}>
                        <div className={this.props.classnameinner}>
                            <div className="ms-Grid" dir="ltr">
                                <MessageBars
                                    errorMessage={this.state.errorMessage}
                                    warningMessage={this.state.warningMessage}
                                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                                />

                                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                                {content}
                            </div>
                        </div>
                    </div>
                </Panel>
            );
        }
    }
}